import { GlobalAppConfig } from "../../types/windowPatching";
import { Url } from "../../general/modules/url";
import { MailingLoginQueryParams } from "./MailingLoginQueryParams";
import { MailingUser } from "./MailingUser";
import { UserSession } from "../../general/modules/user/userSession";

export class BuildMailingUser {
    private readonly mailingToken: string;
    private readonly suid: string;
    private readonly generatedAt: string;
    private readonly url: Url
    private readonly config: GlobalAppConfig;
    private session: UserSession;

    constructor(config: GlobalAppConfig, url: Url, session: UserSession) {
        this.config = config;
        this.mailingToken = url.getQueryParam(MailingLoginQueryParams.TOKEN);
        this.suid = url.getQueryParam(MailingLoginQueryParams.SUID);
        this.generatedAt = url.getQueryParam(MailingLoginQueryParams.GENERATED_AT);
        this.url = url;
        this.session = session;
    }

    public build(): MailingUser | null {
        return this.isMailingUser() ? new MailingUser(this.session.getDeviceId(), this.config, this.url) : null;
    }

    private isMailingUser(): boolean {
        return !!(this.suid
            && this.mailingToken
            && this.url.getQueryParam(MailingLoginQueryParams.PROVIDER_ACTION)
            && this.generatedAt
        );
    }
}
